import { SIGN_IN_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import DareDropIcon from 'root/src/client/public/icons/DareDropIcon.svg'
import TikTokLogo from 'root/src/client/public/icons/tiktok-logo.svg'
import TwitchLogo from 'root/src/client/public/icons/twitch-logo.svg'
import YouTubeIcon from 'root/src/client/public/youtube_social_icon_red.png'
import login from 'root/src/client/logic/auth/thunks/login'
import loginSchema from 'root/src/shared/descriptions/formSchemas/loginSchema'
import loginWith from 'root/src/client/logic/auth/thunks/loginWith'
import providers from 'root/src/shared/constants/providers'
import { registerTerms } from 'root/src/shared/descriptions/modules/signUpModal'
import { colorsNew } from 'root/src/client/web/commonStyles'
import { typographyVariants } from 'root/src/client/web/typography/Typography'

export default {
	[SIGN_IN_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		schema: loginSchema,
		modalContent: {
			title: 'Sign In',
			buttons: [
				{
					label: 'Sign In',
					icon: DareDropIcon,
					type: 'primary',
					iconSize: 20,
					onClick: login,
					htmlType: 'submit',
				},
				{
					label: 'Sign in with Twitch',
					icon: TwitchLogo,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.twitch)(state),
					style: {
						backgroundColor: colorsNew.googleDark,
					},
					typography: typographyVariants.providerSignIn,
					border: `1px solid ${colorsNew.googleBorder}`,
					color: colorsNew.googleText,
				},
				{
					label: 'Sign in with YouTube',
					icon: YouTubeIcon,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.google)(state),
					style: {
						backgroundColor: colorsNew.googleDark,
					},
					border: `1px solid ${colorsNew.googleBorder}`,
					typography: typographyVariants.providerSignIn,
					color: colorsNew.googleText,
				},
				{
					label: 'Sign in with TikTok',
					icon: TikTokLogo,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.tiktok)(state),
					style: {
						backgroundColor: colorsNew.googleDark,
					},
					border: `1px solid ${colorsNew.googleBorder}`,
					typography: typographyVariants.providerSignIn,
					color: colorsNew.googleText,
				},
			],
			registerTerms,
		},
	},
}
